export * from './simulator.page';
